<template><section><h2>Nightingale Stack Chart 堆叠图</h2>
<block-demo tip="" source="const data = [
  {
    product: &quot;05-08&quot;,
    year: &quot;图例一&quot;,
    sales: 30,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例二&quot;,
    sales: 15,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例三&quot;,
    sales: 20,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例一&quot;,
    sales: 30,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例二&quot;,
    sales: 17,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例三&quot;,
    sales: 20,
  },

  {
    product: &quot;05-10&quot;,
    year: &quot;图例一&quot;,
    sales: 17.57,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例二&quot;,
    sales: 24,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例三&quot;,
    sales: 37.54,
  },

  {
    product: &quot;05-11&quot;,
    year: &quot;图例一&quot;,
    sales: 41,
  },
  {
    product: &quot;05-11&quot;,
    year: &quot;图例二&quot;,
    sales: 28,
  },
  {
    product: &quot;05-11&quot;,
    year: &quot;图例三&quot;,
    sales: 21,
  },

  {
    product: &quot;05-12&quot;,
    year: &quot;图例一&quot;,
    sales: 14,
  },
  {
    product: &quot;05-12&quot;,
    year: &quot;图例二&quot;,
    sales: 25,
  },
  {
    product: &quot;05-12&quot;,
    year: &quot;图例三&quot;,
    sales: 35,
  },

  {
    product: &quot;05-13&quot;,
    year: &quot;图例一&quot;,
    sales: 44,
  },
  {
    product: &quot;05-13&quot;,
    year: &quot;图例二&quot;,
    sales: 25,
  },
  {
    product: &quot;05-13&quot;,
    year: &quot;图例三&quot;,
    sales: 10,
  },

  {
    product: &quot;05-14&quot;,
    year: &quot;图例一&quot;,
    sales: 25,
  },
  {
    product: &quot;05-14&quot;,
    year: &quot;图例二&quot;,
    sales: 25,
  },
  {
    product: &quot;05-14&quot;,
    year: &quot;图例三&quot;,
    sales: 10,
  },
  {
    product: &quot;05-15&quot;,
    year: &quot;图例一&quot;,
    sales: 25,
  },
  {
    product: &quot;05-15&quot;,
    year: &quot;图例二&quot;,
    sales: 25,
  },
  {
    product: &quot;05-15&quot;,
    year: &quot;图例三&quot;,
    sales: 10,
  },
]
const { Chart, PolarBar, Tooltip, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  row: &quot;year&quot;,
  value: &quot;sales&quot;,
  text: &quot;product&quot;,
})
const bar = new PolarBar({
  stack: true,
  radius: 0.8,
  groupPadAngle: 15,
}).style(&quot;pillar&quot;, {
  strokeColor: &quot;#FFF&quot;,
  lineWidth: 1,
})
const tooltip = new Tooltip()
const legend = new Legend()

chart.append([bar, tooltip, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">30</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">15</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">20</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">30</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">17</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">20</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">17.57</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">24</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">37.54</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">41</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">28</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">21</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">14</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">25</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">35</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-13"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">44</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-13"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">25</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-13"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">10</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-14"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">25</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-14"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">25</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-14"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">10</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-15"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">25</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-15"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">25</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-15"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">10</span>,
  },
]
<span class="hljs-keyword">const</span> { Chart, PolarBar, Tooltip, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> PolarBar({
  <span class="hljs-attr">stack</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.8</span>,
  <span class="hljs-attr">groupPadAngle</span>: <span class="hljs-number">15</span>,
}).style(<span class="hljs-string">"pillar"</span>, {
  <span class="hljs-attr">strokeColor</span>: <span class="hljs-string">"#FFF"</span>,
  <span class="hljs-attr">lineWidth</span>: <span class="hljs-number">1</span>,
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()

chart.append([bar, tooltip, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>